module.exports = __webpack_public_path__ + "img/moti_3.9b0b56bc.png";